module.exports = __webpack_public_path__ + "static/banner_right_circles-17fdbe5838d32a81bac83494fe620fd5.png";